export default __webpack_public_path__ + "static/media/manual-search-result.fa13cec0.png";